import { render, staticRenderFns } from "./DetectionWriteDefaultLayout.vue?vue&type=template&id=158d79b0&scoped=true&"
import script from "./DetectionWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./DetectionWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158d79b0",
  null
  
)

export default component.exports